
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcSequenceLoadingSpinner as ObcSequenceLoadingSpinnerElement} from '@oicl/openbridge-webcomponents/dist/components/sequence-loading-spinner/sequence-loading-spinner.js';
 
 
 

 
 export const ObcSequenceLoadingSpinner = createComponent({
   react: React,
   tagName: 'obc-sequence-loading-spinner',
   elementClass: ObcSequenceLoadingSpinnerElement,
   events: {
     
   }
  });
 
 